import { config } from "JS/Config";
import { appConstants } from "JS/Helpers/Constants";
import { BaseService } from "../BaseService";

export class PaymentEligibleUsersService extends BaseService {
    isPaymentEligibleUser(): Promise<boolean> {
        return this.ngCall<boolean>(
            "get",
            appConstants.ngEndpoints.paymentEligibleUser(config.user.memberId),
        ).then((response) => response.data);
    }
}
